import { Box, Paper } from "@bvhi/ui-base";
import { ReactNode, useEffect, useRef, useState } from "react";
import { ActionCard } from "./action-card";

interface FormWithActionCardProps {
  children: ReactNode;
  actionCardContent: ReactNode;
  contained?: boolean;
}

export const FormWithActionCard = ({ children, contained, actionCardContent }: FormWithActionCardProps) => {
  const [isFloating, setIsFloating] = useState(false);
  const spacerRef = useRef(null);

  useEffect(() => {
    const spacer = spacerRef.current;
    if (!spacer) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFloating(!entry.isIntersecting);
      },
      {
        root: null,
        threshold: 1.0,
      }
    );

    observer.observe(spacer);

    return () => {
      if (!spacer) return;
      observer.unobserve(spacer);
    };
  }, []);

  const content = (
    <>
      {children}
      <Box marginTop={2} />
      <ActionCard elevation={isFloating ? 10 : 0}>{actionCardContent}</ActionCard>
      <div ref={spacerRef} className="spacer" style={{ transform: "translateY(24px)" }}></div>
    </>
  );

  return contained ? <Paper>{content}</Paper> : <Box>{content}</Box>;
};
